'use client';

import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from '../icons';

interface ICounterProps {
  count: number;
  increment: () => void;
  decrement: () => void;
}

export const Counter = ({ count, increment, decrement }: ICounterProps) => {
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);

  const handleMouseDown = (action: () => void) => {
    const id = setInterval(action, 100);
    setIntervalId(id);
  };

  const handleMouseUp = () => {
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }
  };

  return (
    <div className="flex flex-row gap-3 items-center">
      <button
        className="h-10 w-10 flex items-center justify-center rounded-full border border-gray-800"
        onClick={decrement}
        onMouseDown={() => handleMouseDown(decrement)}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        <MinusIcon />
      </button>
      <span className="font-inter text-md font-medium min-w-6 text-center cursor-default">{count}</span>
      <button
        className="h-10 w-10 flex items-center justify-center rounded-full border border-gray-800"
        onClick={increment}
        onMouseDown={() => handleMouseDown(increment)}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp} // To stop when the mouse leaves the button
      >
        <PlusIcon />
      </button>
    </div>
  );
};
